const ContactInfo = () => {
    return (
        <div className="contactsInfo">
            <h3>Contattaci</h3>
            <div className="contactsInfo__content">
                <div className="contactsInfo__content__phone">
                    <i className="fa fa-phone" />
                    <span>02-82476790</span>
                </div>
                <div className="contactsInfo__content__mail">
                    <i className="fa fa-envelope" />
                    <a href="mailto:info@altalex.com">info@altalex.com</a>
                </div>
            </div>
        </div>
    )
}

export default ContactInfo;